export default {
  siteName: 'ZhaiZhai Resource Hub',
  heroTitle: 'ZhaiZhai Resource Hub',
  heroSubtitle: 'A resource aggregation platform for anime enthusiasts, covering anime, manga, games, light novels and more.',
  exploreBtn: 'Explore Now',
  learnMore: 'Learn More',
  categoryTitle: 'Explore Categories',
  categoryDesc: 'Six resource categories covering all your otaku needs',
  hotResources: 'Hot Resources',
  hotResourcesDesc: 'Most popular resources from the community',
  viewAll: 'View All',
  latestUpdates: 'Latest Updates',
  latestUpdatesDesc: 'Updated daily, never miss great content',
  statsUsers: 'Registered Users',
  statsResources: 'Total Resources',
  statsPosts: 'Community Posts',
  statsUptime: 'Uptime',
  faqTitle: 'Frequently Asked Questions',
  faqDesc: 'Everything you might want to know about ZhaiZhai',
  ctaTitle: 'Join Millions of Otaku',
  ctaDesc: 'Massive resources updated daily, warm community atmosphere.',
  ctaBtn: 'About ZhaiZhai',
  footerDesc: 'A resource aggregation platform for anime enthusiasts.',
  footerCategories: 'Categories',
  footerQuickLinks: 'Quick Links',
  footerFollow: 'Follow Us',
  footerEmail: 'Contact Email',
  footerCopyright: '© 2024-2026 ZhaiZhai Resource Hub - All Rights Reserved',
  navHome: 'Home',
  navAnime: 'Anime',
  navManga: 'Manga',
  navGame: 'Games',
  navLightNovel: 'Light Novels',
  navAbout: 'About',
  navJoin: 'Join Us',
  breadcrumbHome: 'Home',
  aboutTitle: 'About Us',
  missionTitle: 'Our Mission',
  visionTitle: 'Our Vision',
  milestonesTitle: 'Milestones',
  testimonialsTitle: 'Testimonials',
  contactTitle: 'Contact Us',
  contactInfo: 'Contact Info',
  contactMessage: 'Send a Message',
};